import { createSlice } from "@reduxjs/toolkit";
import type { NavigationNode } from "~/domains/navigation/types/NavigationTypes";
import type { CategoryNavigationState } from "~/features/navigation/redux/types";
import { loadNavigation } from "~/features/navigation/redux/navigationThunks";

const EMPTY_ROOT: NavigationNode = {
  id: -1,
  gaLabel: "",
  title: "",
  level: -1,
  openInNewTab: false,
  children: [],
  usefulTools: [],
  showSeriesTree: false,
};

interface NavigationSliceState {
  isLoading: boolean;
  categoryNavigation: CategoryNavigationState;
  flyoutNodes: NavigationNode[];
}

const initialState: NavigationSliceState = {
  isLoading: false,
  categoryNavigation: {
    root: EMPTY_ROOT,
    nodes: {},
  },
  flyoutNodes: [],
};

const navigationSlice = createSlice({
  name: "navigation",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loadNavigation.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(loadNavigation.fulfilled, (state, action) => {
        state.isLoading = false;
        state.categoryNavigation.root = action.payload.root;
        state.categoryNavigation.nodes = action.payload.nodes;
        state.flyoutNodes = action.payload.flyoutNodes;
      })
      .addCase(loadNavigation.rejected, (state) => {
        state.isLoading = false;
      });
  },
});

export default navigationSlice.reducer;
